<template>
  <div class="signInd">
    <el-dialog v-bind="$attrs" v-on="$listeners" :title="$t('signIn.签到')" class="dialog-dark dialog-center" width="400px">
      <div class="signStop">
        <p class="nameText">{{ $t("signIn.当前签到人数", [count]) }}</p>
        <div class="progress">
          <el-progress :width="96" :percentage="percent" :show-text="false" :color="themeColor" type="circle">
          </el-progress>
          <div class="progress-text">
            <span>{{ percent }}%</span>
            <div class="progress-text__tip">{{ $t("signIn.签到率") }}</div>
          </div>
        </div>
        <p class="nameText">
          {{ $t("signIn.签到人数") }} <span class="count">{{ count }}</span> /{{ total }}
        </p>
        <div v-if="range != 1 && count > 0">
          <a href="javascript:;" @click="showSignDetail" class="view-detail">{{ $t("signIn.查看签到明细")}}</a>
        </div>
        <!-- <div class="sign-btns">
          <el-button
            class="sign-btns-btn"
            type="primary"
            size="mini"
            @click="reSignIn()"
            >{{ $t("signIn.重新签到") }}</el-button
          >
        </div> -->
      </div>
      <el-dialog
        width="380px"
        :title="$t('signIn.签到')"
        :visible.sync="showDetail"
        append-to-body
        class="dialog-dark dialog-center"
        >
        <div class="signStop">
         <p class="nameText sign-number-content">{{ $t("signIn.当前签到嘉宾", [list.length]) }}</p>
         <div class="sign-content">
            <div v-for="(item,index) of list" :key="index" class="sign-item">
              {{ item.nickname }}
            </div>
         </div>
        </div>
      </el-dialog>
    </el-dialog>
  </div>
</template>

<script>
import { Progress } from "element-ui";
import { pushRoomMessageFunc } from "@/utils/socketMessageDispose";
import { rollcall } from "@/api/liveRequest/rollcalls";
import { mapGetters } from "vuex";
export default {
  components: {
    [Progress.name]: Progress,
  },
  props: {
    count: Number,
    total: Number,
    limit: Number,
  },
  computed: {
    ...mapGetters(["confId"]),
    percent() {
      return ((this.count / this.total) * 100) >> 0;
    },
    themeColor(){
      const theme = document.querySelector('html').getAttribute("data-theme")
      return theme == 'Blue' ? "#3986ee" : "#F89B33"
    }
  },
  data() {
    return {
      showDetail: false,
      list: [],
      pageSize: 10000,
      pageNum: 1,
      signInId: '',
      range: 0
    }
  },
  created() {
    pushRoomMessageFunc(({ cmd, requestData }) => {
      const fn = this[`message_${cmd}`];
      typeof fn === "function" && fn(requestData);
    });
  },
  methods: {
    reSignIn() {
      if (this.limit > 0) {
        this.$message({
          type: "warning",
          message: this.$t("signIn.两次签到最小间隔不能小于60秒"),
          duration: 2000,
        });
        return;
      }
      this.$emit("reStart", false);
    },
    async showSignDetail() {
      const { code, data } = await rollcall.list({pageNum: this.pageNum, pageSize: this.pageSize},this.signInId);
      if(code === 200){
        this.list = data.users;
      }
      this.showDetail = true;
    },
    message_7127(body) {
      switch (body.event) {
        case "rollcall/statistics":
          this.signInId = body.id;
          this.range = body.range;
          break;
      }
    },
    message_7107(body) {
      switch (body.event) {
        case "rollcall/state":
          this.range = body.range;
          this.signInId = body.id;
          break;
      }
    }
  },
};
</script>

<style scoped lang="scss">
::v-deep {
    .el-dialog__body {
      padding-top: 10px;
      font-size: 12px;
    }
}
.signInd {
  ::v-deep {
    .el-progress {
      vertical-align: middle;
    }

    .el-progress-circle__track {
      stroke-opacity: 0.3;
    }
  }
}

.progress {
  position: relative;
  margin: 22px auto;
  width: 96px;
  height: 96px;

  &-text {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    text-align: center;

    span {
      font-size: 24px;
      color: #fff;
    }

    &__tip {
      font-size: 12px;
      color: #8a8f99;
    }
  }
}

.sign-btns {
  margin-top: 16px;
  text-align: center;

  &-btn {
    border-radius: 6px;
  }
}
.view-detail{
  color:#3986EE;
  text-decoration: none;
  line-height: 28px;
  justify-content: center;
  align-items: center;
}
.sign-content{
  max-height:120px;
  overflow-y: auto;
  display: flex;
  flex-wrap: wrap;
  padding-top: 10px;
  margin-top: 10px;
}
.sign-item {
  width: 33.33%;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  line-height: 24px;
}
.sign-number-content{
  text-align: center;
  font-size: 12px;
}
</style>